import { Component, Input, OnInit } from '@angular/core';
import { UserDetailService } from 'src/services/user-details.service';

@Component({
  selector: 'app-user-item',
  templateUrl: './user-item.component.html',
  styleUrls: ['./user-item.component.css']
})
export class UserItemComponent implements OnInit {


  @Input() userDetail;

  constructor(private userservice: UserDetailService) { }

  ngOnInit(): void {
  }

  getAgentPageUrl(name) {

    //const url = "/" + name.split(" ").join("");
    this.userservice.setUserDetails(this.userDetail);

  }

  getImageUrl(imageUrl) {
    if(imageUrl === "empty") {
      return "../../../assets/images/empty-profile.png"
    } else {
      return imageUrl
    }
  }



}
